// // components/Investments/LaunchOperatingModel.tsx
// "use client";

// import * as React from "react";
// import { Box, Stack, Typography } from "@mui/material";
// import Image from "next/image";
// import Heading from "../heading";
// import CtaButton from "../buttonWithArrow";

// export default function LaunchOperatingModel({ data }) {
//     const { title, subtitle, steps = [], button, borderImages } = data;

//     // tune to your asset exports
//     const RADIUS = 16;         // frame corner radius
//     const INNER_PAD = 18;      // padding inside frame
//     const ARROW_BLEED = 24;    // how far arrow should extend into the gap
//     const MIN_H = 260;         // min card height on desktop
//     const teal = "#2fb2af";

//     const getBorderFor = (i) => {
//         if (!borderImages) return undefined;
//         if (i === 0) return borderImages.first;
//         if (i === steps.length - 1) return borderImages.last;
//         return borderImages.middle;
//     };

//     return (
//         <Box component="section" sx={{ bgcolor: "#f7f9f9", py: { xs: 6, md: 8 } }}>
//             <Heading title={title} subtitle={subtitle} />

//             <Box sx={{ maxWidth: 1400, mx: "auto", px: { xs: 2, md: 3 } }}>
//                 {/* Mobile: stack, simple teal border */}
//                 <Box
//                     sx={{
//                         display: { xs: "grid", md: "none" },
//                         gridTemplateColumns: "1fr",
//                         rowGap: 2,
//                     }}
//                 >
//                     {steps.map((s, i) => (
//                         <Box
//                             key={i}
//                             sx={{
//                                 position: "relative",
//                                 border: `3px solid ${teal}`,
//                                 borderRadius: RADIUS,
//                             }}
//                         >
//                             <Box
//                                 sx={{
//                                     position: "relative",
//                                     borderRadius: RADIUS - 4,
//                                     overflow: "hidden",
//                                     padding: INNER_PAD,
//                                 }}
//                             >
//                                 <CardContent teal={teal} step={s} />
//                             </Box>
//                         </Box>
//                     ))}
//                 </Box>

//                 {/* Desktop: one row, transparent cards, absolute content box */}
//                 <Box
//                     sx={{
//                         display: { xs: "none", md: "grid" },
//                         gridTemplateColumns: `repeat(${steps.length}, minmax(240px, 1fr))`,
//                         columnGap: `${ARROW_BLEED + 8}px`, // gap ~ a bit wider than the arrow
//                         alignItems: "stretch",
//                     }}
//                 >
//                     {steps.map((s, i) => {
//                         const borderSrc = getBorderFor(i);
//                         const isLast = i === steps.length - 1;

//                         return (
//                             <Box
//                                 key={i}
//                                 sx={{
//                                     position: "relative",
//                                     borderRadius: RADIUS,
//                                     minHeight: MIN_H,
//                                     background: "transparent",
//                                     overflow: "visible", // allow arrow to bleed into the gap
//                                 }}
//                             >
//                                 {/* Frame overlay (extends into the gap on the right) */}
//                                 {borderSrc && (
//                                     <Box
//                                         aria-hidden
//                                         sx={{
//                                             position: "absolute",
//                                             top: 0,
//                                             bottom: 0,
//                                             left: 0,
//                                             right: isLast ? 0 : `-${ARROW_BLEED}px`,
//                                             borderRadius: RADIUS,
//                                             pointerEvents: "none",
//                                             zIndex: 2,
//                                         }}
//                                     >
//                                         <Image src={borderSrc} alt="" fill style={{ objectFit: "fill" }} />
//                                     </Box>
//                                 )}

//                                 {/* Absolute content area — ALWAYS inside the frame */}
//                                 <Box
//                                     sx={{
//                                         position: "absolute",
//                                         top: INNER_PAD,
//                                         bottom: INNER_PAD,
//                                         left: 46,
//                                         right: isLast ? INNER_PAD : INNER_PAD + ARROW_BLEED, // keep clear of the arrow
//                                         // borderRadius: RADIUS - 4,
//                                         overflow: "hidden", // clamp to inner rounded rect
//                                         background: "transparent",
//                                         zIndex: 1,
//                                         display: "flex",
//                                         flexDirection: "column",
//                                     }}
//                                 >
//                                     <CardContent teal={teal} step={s} />
//                                 </Box>
//                             </Box>
//                         );
//                     })}
//                 </Box>

//                 {button && (
//                     <Stack alignItems="center" sx={{ mt: { xs: 4, md: 6 } }}>
//                         <CtaButton cta={{ label: button.text, href: button.link }} />
//                     </Stack>
//                 )}
//             </Box>
//         </Box>
//     );
// }

// function CardContent({ teal, step }) {
//     return (
//         <>
//             <Typography
//                 sx={{
//                     fontWeight: 800,
//                     fontSize: { xs: 16, md: 16 },
//                     color: "#0f1115",
//                     mb: 1.25,
//                     lineHeight: 1.25,
//                 }}
//             >
//                 {step.title}
//             </Typography>

//             <Stack component="ul" spacing={1} sx={{ m: 0, p: 0, listStyle: "none" }}>
//                 {step.items.map((t, i) => (
//                     <Stack key={i} direction="row" spacing={1.25} alignItems="flex-start">
//                         <Box sx={{ mt: "7px", width: 13, height: 7, borderRadius: "50%", bgcolor: teal }} />
//                         <Typography
//                             component="li"
//                             sx={{ color: "#556070", fontSize: { xs: 12, md: 13 }, lineHeight: 1.55, ml: "5px" }}
//                         >
//                             {t}
//                         </Typography>
//                     </Stack>
//                 ))}
//             </Stack>
//         </>
//     );
// }

// RoiInvestorBenefits.tsx
/* eslint-disable @next/next/no-img-element */
import * as React from "react";
import { Box, Paper, Stack, Typography, Grid } from "@mui/material";
import CtaButton from "../buttonWithArrow"; // or replace with your own CTA button
import Heading from "../heading";
import Image from "next/image";

const MAX_W = 1300;     // section content cap
const IMG_W = 1200;      // max width for the illustration

export default function RoiInvestorBenefits({ data, onClick }) {
    const { title, subtitle, button, image, showSparkle, bgcolor, width } = data;
    return (
        <Box
            component="section"
            sx={{
                py: { xs: 8, md: 4 },
                px: { xs: 2, sm: 3 },
                bgcolor: bgcolor ?? "#f7f9f9",
            }}
        >
            {/* Header */}
            <Heading title={title} subtitle={subtitle} lineClamp={showSparkle ? 2 : 1} showSparkle={showSparkle ? "/img/investments/Sparkle.svg" : undefined} mb={5} />

            {/* Illustration + floating pills */}
            <Box sx={{ maxWidth: MAX_W, mx: "auto" }}>
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        maxWidth: IMG_W,
                        mx: "auto",
                        display: "flex",
                        justifyContent: "center"
                    }}
                >
                    <Box
                        component="img"
                        src={image?.src} // <-- change to your image path
                        alt={image?.alt}
                        loading="lazy"
                        style={{ width: width ?? "100%", height: "auto", display: "block" }}
                    />
                </Box>

                {/* CTA */}
                {
                    button &&
                    <Stack alignItems="center" sx={{ mt: { xs: 4, md: 5 } }}>
                        <CtaButton label={button?.text} onClick={() => onClick()} />
                        {/* <CtaButton cta={{ label: button?.text, href: button?.link }} /> */}
                    </Stack>
                }
            </Box>
        </Box>
    );
}
